'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const _ = {
    find: require('lodash/find'),
};

const Globals = require('../../../../app/globals');
import WarningBox from '../common/WarningBox';
const ForgeError = require('../../util/error');

const propTypes = {
    serviceData: PropTypes.object.isRequired,
    submitHandler: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
    show: true,
};

class OrgAddBadgeTemplateModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            third_party_badge_template_id: '',
        };
    }

    submitHandler=(e)=>{
        this.props.submitHandler({
            service_id: this.props.serviceData.id,
            third_party_badge_template_id: this.state.third_party_badge_template_id
        });
    }
    
    render() {
        return (
            <Modal
                show={this.props.show}
                size="lg"
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>{"Add Badge Template"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group controlId="modal-add-badge-template-service-name">
                            <Form.Label>{'Type'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Badge Service'}
                                readOnly
                                value={this.props.serviceData.name}
                            />
                        </Form.Group>

                        <Form.Group controlId="modal-add-badge-template-id">
                            <Form.Label>{'Template ID'}</Form.Label>
                            <Form.Control
                                as={'input'}
                                aria-label={'Template ID'}
                                value={this.state.third_party_badge_template_id}
                                onChange={(e)=>{
                                    this.setState({third_party_badge_template_id:e.target.value})
                                }}
                            />
                        </Form.Group>

                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button disabled={!this.state.third_party_badge_template_id} onClick={this.submitHandler}>
                        add badge template
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

OrgAddBadgeTemplateModal.propTypes = propTypes;
OrgAddBadgeTemplateModal.defaultProps = defaultProps;

export default OrgAddBadgeTemplateModal;